<template>
    <v-card v-if="promotion" flat>
        <v-card-title>{{ promotion.name }}</v-card-title>

        <div class="promo-detail__text">
            <v-card-text v-html="promotion.detail"/>
        </div>
    </v-card>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'PromoDetailScreen',

        data: () => ({
            promotionId: undefined,
        }),

        computed: {
            ...mapState('promotion', {
                promotions: state => state.promotions,
            }),

            promotion() {
                return this.promotions[this.promotionId]
            },
        },

        mounted() {
            this.promotionId = this.$route.params?.promotionId

            this.$store.dispatch('promotion/fetchById', this.promotionId)
        },
    }
</script>
